import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../services/RestApiService';

function getPersonalSpaceRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.13',
    httpMethod: 'GET',
    endpoint: 'personalSpace',
    serverWideRequest: false
  };
}

export type PersonalSpaceInfo = {
  readonly luid: string;
  readonly ownerLuid: string;
  readonly readOnly: boolean;
}

export type GetPersonalSpaceResponse = {
  readonly personalSpace: PersonalSpaceInfo;
}

export function callViaApiService() {
  return makeJsonRestApiRequest<void, GetPersonalSpaceResponse>({
    config: getPersonalSpaceRequestConfig(),
    request: null,
  });
}
